export default "__VITE_ASSET__DTx4vKtK__"